import { render, staticRenderFns } from "./cashier.vue?vue&type=template&id=67dd61d3&scoped=true"
import script from "./cashier.vue?vue&type=script&lang=js"
export * from "./cashier.vue?vue&type=script&lang=js"
import style0 from "./cashier.vue?vue&type=style&index=0&id=67dd61d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67dd61d3",
  null
  
)

export default component.exports